import OUTPUT from "./OUTPUT";
import { Link } from "react-router-dom";

const PATHS = {
  login: {
    key: "login",
    path: "/login",
    name: "Login",
    nested: null,
    icon: null,
    private: false,
  },
  "email-confirm": {
    key: "email-confirm",
    path: "/email-confirm/:code",
    name: "Confirmação de Email",
    nested: null,
    icon: null,
    private: false,
  },
  "change-password": {
    key: "change-password",
    path: "/change-password/:code",
    name: "Trocar Senha",
    nested: null,
    icon: null,
    private: false,
  },
  "esqueci-senha": {
    key: "esqueci-senha",
    path: "/esqueci-senha/:username",
    name: "Esqueci minha senha",
    nested: null,
    icon: null,
    private: false,
  },
  home: {
    key: "home",
    path: "/",
    name: "Home",
    nested: null,
    icon: "home",
    private: false,
  },
  dashboard: {
    key: "dashboard",
    path: "/dashboard",
    name: "Dashboard",
    nested: null,
    icon: "control_panel",
    private: true,
  },
  sobre: {
    key: "sobre",
    path: "/sobre",
    name: "Sobre",
    nested: null,
    icon: null,
    private: false,
  },
  empresas: {
    key: "empresas",
    path: "/empresas",
    name: "Empresas",
    nested: null,
    icon: "office_building",
    private: false,
    // handle: {
    //   crumb: () => <Link to="/messages">Messages</Link>,
    // },
  },
  ativos: {
    key: "ativos",
    path: "/ativos",
    name: "Ativo",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  cnt: {
    key: "cnt",
    path: "/contas",
    name: "Contas",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  pou: {
    key: "pou",
    path: "/poupancas",
    name: "Poupanças",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  prv: {
    key: "prv",
    path: "/previdencias",
    name: "Previdências",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  fnd: {
    key: "fnd",
    path: "/fundos",
    name: "Fundos de Investimentos",
    nested: null,
    icon: "fund",
    private: false,
  },
  tpu: {
    key: "tpu",
    path: "/titulos-publicos",
    name: "Títulos Públicos",
    nested: null,
    icon: "pub_bond",
    private: false,
  },
  tpr: {
    key: "tpr",
    path: "/titulos-privados",
    name: "Títulos Privados",
    nested: null,
    icon: "pri_bond",
    private: false,
  },
  tba: {
    key: "tba",
    path: "/titulos-bancarios",
    name: "Títulos Bancários",
    nested: null,
    icon: "bank_bond",
    private: false,
  },
  acn: {
    key: "acn",
    path: "/acoes",
    name: "Ações",
    nested: null,
    icon: "stock",
    private: false,
  },
  fgt: {
    key: "fgt",
    path: "/fgts",
    name: "FGTS",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  dri: {
    key: "dri",
    path: "/derivativso",
    name: "Derivativos",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  crp: {
    key: "crp",
    path: "/criptomoedsa",
    name: "Criptomoedas",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  imv: {
    key: "imv",
    path: "/imoveis",
    name: "Imóveis",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  vei: {
    key: "vei",
    path: "/veiculos",
    name: "Veículos",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  car: {
    key: "car",
    path: "/cartoes",
    name: "Cartões",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  moe: {
    key: "moe",
    path: "/moedas-estrangeiras",
    name: "Moedas Estrangeiras",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  agr: {
    key: "agr",
    path: "/agronegocios",
    name: "Agronegócios",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  mtl: {
    key: "mtl",
    path: "/metais-nobres",
    name: "Metais Nobres",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  pdr: {
    key: "pdr",
    path: "/pedras-preciosas",
    name: "Pedras Preciosas",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  art: {
    key: "art",
    path: "/obras-artes",
    name: "Obras de Artes",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  fdl: {
    key: "fdl",
    path: "/programas-fidelidade",
    name: "Programas de Fidelidade",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  seg: {
    key: "seg",
    path: "/seguros",
    name: "Seguros",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  bem: {
    key: "bem",
    path: "/outros-bens",
    name: "Outros Bens",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  cbl: {
    key: "cbl",
    path: "/contabil",
    name: "Contábil",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  etf: {
    key: "etf",
    path: "/etfs",
    name: "ETFs",
    nested: null,
    icon: "paper_ribbon",
    private: false,
  },
  indicadores: {
    key: "indicadores",
    path: "/indicadores",
    name: "Indicadores",
    nested: null,
    icon: "chart_line",
    private: false,
  },
  ferramentas: {
    key: "ferramentas",
    path: "/ferramentas",
    name: "Ferramentas",
    icon: "wrench",
    private: false,
    nested: [
      {
        key: "calculadoras",
        path: "/calculadoras",
        name: "Calculadoras",
        icon: "calculator",
      },
      // {
      //   key: "cotacoes",
      //   path: "/cotacoes",
      //   name: "Cotações",
      //   icon: "chart_line",
      // },
      // {
      //   key: "indicadores",
      //   path: "/indicadores",
      //   name: "Indicadores",
      //   icon: "chart_lines",
      // },
      {
        key: "empresas",
        path: "/empresas",
        name: "Empresas",
        icon: "office_building",
      },
      {
        key: "ativos",
        path: "/ativos",
        name: "Ativos",
        icon: "box_3d",
      },
    ],
  },
  calculadoras: {
    key: "calculadoras",
    path: "/calculadoras",
    name: "Calculadoras",
    nested: null,
    icon: "calculator",
    private: false,
  },
  configuracoes: {
    key: "configuracoes",
    path: "/configuracoes",
    name: "Configurações",
    private: true,
    nested: {
      entidades: {
        key: "entidades",
        label: "Entidades",
        icon: "wallet",
        path: "/entidades",
        nested: {
          membros: {
            key: "membros",
            label: "Membros",
            icon: "users",
            path: "/entidades/membros",
          },
          "recurso-garantidor": {
            key: "recurso-garantidor",
            label: "Recurso Garantidor",
            icon: "safe",
            path: "/entidades/recurso-garantidor",
          },
        },
      },
      "alterar-senha": {
        key: "alterar-senha",
        label: "Alterar Senha",
        icon: "key",
        path: "/alterar-senha",
        nested: [],
      },
      "fundos-fechados": {
        key: "fundos-fechados",
        label: "Fundos Excepcionalmente Não Abertos",
        icon: "wallet",
        path: "/fundos-fechados",
        nested: [],
      },
    },
    icon: "gear",
  },
  notificacoes: {
    key: "notificacoes",
    path: "/notificacoes",
    name: "Notificações",
    nested: null,
    icon: "bell",
    private: true,
  },
  portfolios: {
    key: "portfolios",
    path: "/portfolios",
    name: "Portfolios",
    nested: null,
    icon: "portfolio",
    private: true,
  },
  carteiras: {
    key: "carteiras",
    path: "/carteiras",
    name: "Carteiras",
    nested: null,
    icon: "wallet",
    private: true,
  },
  reports: {
    key: "reports",
    path: "/reports",
    name: "Relatórios",
    nested: [
      {
        key: OUTPUT.duration.id,
        name: OUTPUT.duration.descricao,
        path: `/reports/${OUTPUT.duration.id}`,
        icon: "paper",
      },
      {
        key: OUTPUT.var.id,
        label: OUTPUT.var.descricao,
        path: `/reports/${OUTPUT.var.id}`,
        icon: "paper",
      },
      {
        key: OUTPUT.enquadramento.id,
        label: OUTPUT.enquadramento.descricao,
        path: `/reports/${OUTPUT.enquadramento.id}`,
        icon: "paper",
      },
      {
        key: OUTPUT.raiox.id,
        label: OUTPUT.raiox.descricao,
        path: `/reports/${OUTPUT.raiox.id}`,
        icon: "paper",
      },
      {
        key: OUTPUT.rentabilidade.id,
        label: OUTPUT.rentabilidade.descricao,
        path: `/reports/${OUTPUT.rentabilidade.id}`,
        icon: "paper",
      },
      {
        key: OUTPUT.stresstest.id,
        label: OUTPUT.stresstest.descricao,
        path: `/reports/${OUTPUT.stresstest.id}`,
        icon: "paper",
      },
      {
        key: OUTPUT.backtesting.id,
        label: OUTPUT.backtesting.descricao,
        path: `/reports/${OUTPUT.backtesting.id}`,
        icon: "paper",
      },
      {
        key: OUTPUT.fronteiraeficiente.id,
        label: OUTPUT.fronteiraeficiente.descricao,
        path: `/reports/${OUTPUT.fronteiraeficiente.id}`,
        icon: "paper",
      },
    ],
    icon: "papers",
    private: true,
  },
  "carteiras-abertas": {
    key: "carteiras-abertas",
    path: "/carteiras-abertas",
    name: "Carteiras Abertas",
    nested: null,
    icon: "open_wallet",
    private: true,
  },
  simulacoes: {
    key: "simulacoes",
    path: "/simulacoes",
    name: "Simulacoes",
    nested: null,
    icon: "lab",
    private: true,
  },
  uploads: {
    key: "uploads",
    path: "/uploads",
    name: "Uploads",
    nested: null,
    icon: "upload",
    private: true,
  },
};

export default PATHS;
